import { useGetPatientIntakeConsultationSummary } from "./useGetPatientIntakeConsultationSummary";
import { useGetPatientScreeningConsultationSummary } from "./useGetPatientScreeningConsultationSummary";

export const useGetPatientConsultationSummary = (
  consultationId?: string,
  consultationHasScreeningSummary?: boolean,
  consultationHasIntakeSummary?: boolean,
) => {
  const {
    data: screeningSummaryData,
    isLoading: isLoadingScreeningSummaryData,
  } = useGetPatientScreeningConsultationSummary(
    consultationId,
    consultationHasScreeningSummary,
  );

  const { data: intakeSummaryData, isLoading: isLoadingIntakeSummaryData } =
    useGetPatientIntakeConsultationSummary(
      consultationId,
      consultationHasIntakeSummary,
    );

  const isLoading = isLoadingScreeningSummaryData || isLoadingIntakeSummaryData;

  return { isLoading, screeningSummaryData, intakeSummaryData };
};
